export default "__VITE_ASSET__c6077685__"